import { Box, Typography, Rating, TextField, Button } from "@mui/material";
import { styled, alpha } from '@mui/material/styles';

export const FeedbackContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius,
  // boxShadow: theme.shadows[1], // Optional
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.1rem',
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(2),
}));

export const StarContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
}));

export const StyledRating = styled(Rating)(({ theme }) => ({
  '& .MuiRating-iconEmpty': {
    color: '#FFC107', // Use the yellow color for empty stars too, or a lighter grey like theme.palette.grey[300]
  },
  '& .MuiRating-iconFilled': {
    color: '#FFC107', // Yellow color for filled stars
  },
  '& .MuiRating-iconHover': {
    color: '#FFC107', // Yellow color on hover
  },
}));

export const CommentBox = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  '& .MuiOutlinedInput-root': {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.grey[50], // Very light grey background
    '& fieldset': {
      borderColor: theme.palette.grey[300],
    },
    '&:hover fieldset': {
      borderColor: theme.palette.grey[400],
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.success.main, // Green border on focus
    },
  },
  '& .MuiInputBase-input::placeholder': {
    color: theme.palette.text.secondary,
    opacity: 1,
  },
}));

export const ButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  flex: 1, // Takes up 50% width
  borderColor: theme.palette.success.main, // Using success green for border
  color: theme.palette.success.main,
  textTransform: 'none',
  fontWeight: 600,
  padding: theme.spacing(1.2),
  fontSize: '1rem',
  borderRadius: '8px',
  '&:hover': {
    borderColor: theme.palette.success.dark,
    backgroundColor: alpha(theme.palette.success.main, 0.04),
  },
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
  flex: 1,
  backgroundColor: '#568A73', // Solid green background
  color: theme.palette.common.white, // White text
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '1rem',
  padding: theme.spacing(1.2),
  borderRadius: '8px',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#357158', // Darker green on hover
    boxShadow: 'none',
  },
}));